import camelcaseKeys from "src/utils/camelCaseKeys";

const adaptObservationQuestions = (questions?: IObservationQuestion[]) => {
	if (!questions) return [];

	const observationQuestions: ObservationQuestion[] = questions.map(
		(question) => {
			const { order } = question;

			// Backend uses "none" for non-branching questions, frontend expects "NEXT"
			const branchType =
				!question.branch_type || question.branch_type === "none"
					? "NEXT"
					: question.branch_type;

			const newQuestion: ObservationQuestion = {
				...camelcaseKeys(question),
				branches: question.branches,
				branchType,
				questionNumber: order,
				questionType: question.question_type,
				givenAnswer: ""
			};

			return newQuestion;
		}
	);

	return observationQuestions;
};

export default adaptObservationQuestions;
